import React from 'react';
import BaseIcon from './BaseIcon.js';

const IconFlagPo = function ({ size }) {
  return (
    <BaseIcon viewBox="0 0 512 512" size={size}>
      <g>
        <rect fill="#3D9244" height="298.7" width="512" y="106.7" />
        <polygon fill="#EDC223" points="78.9,256 256,369.1 433.1,256 256,142.9  " />
        <path fill="#31276C" d="M330.7,256c0,41.2-33.5,74.7-74.7,74.7c-41.2,0-74.7-33.4-74.7-74.7   c0-41.2,33.4-74.7,74.7-74.7C297.2,181.3,330.7,214.8,330.7,256" />
        <path fill="#FFFFFF" d="M213.3,224c-8.7,0-17.3,0.6-25.6,1.8c-1.6,3.7-2.9,7.5-4,11.4c9.6-1.7,19.5-2.6,29.6-2.6   c43.8,0,83.7,16.5,113.9,43.6c1.2-3.8,2.1-7.8,2.7-11.8C298.4,240,257.7,224,213.3,224" />
      </g>
    </BaseIcon>
  );
}

export default IconFlagPo;